import React, { Fragment } from 'react';
import styled from 'styled-components';

import { getTranslatedString } from 'helpers/i18n';

import { MdCheck } from 'react-icons/md';
import { MdFiberManualRecord } from 'react-icons/md';
import { colors } from 'helpers/ColorHelper';
import {
  validatePasswordLength,
  validatePasswordHasNumber,
  validatePasswordHasUpper,
  validatePasswordHasLower,
  validatePasswordHasSpecialChar,
  passwordConfirmationValidation,
} from 'helpers/PasswordHelper';

const PasswordRequirements = (password, password_confirmation) => {
  const passwordsMatch = passwordConfirmationValidation(password, password_confirmation);

  return (
    <Fragment>
      <h4 style={{ padding: 0, textAlign: 'left' }}>
        {getTranslatedString('passwordRequirements')}
      </h4>
      <RequirementRow
        passed={validatePasswordLength(password)}
        translatedText={getTranslatedString('passwordCharacterLength')}
      />
      <RequirementRow
        passed={validatePasswordHasNumber(password)}
        translatedText={getTranslatedString('passwordOneNumber')}
      />
      <RequirementRow
        passed={validatePasswordHasUpper(password)}
        translatedText={getTranslatedString('passwordOneUppercase')}
      />
      <RequirementRow
        passed={validatePasswordHasLower(password)}
        translatedText={getTranslatedString('passwordOneLowercase')}
      />
      <RequirementRow
        passed={validatePasswordHasSpecialChar(password)}
        translatedText={getTranslatedString('passwordSpecialCharacter')}
      />
      <RequirementRow
        passed={passwordsMatch}
        translatedText={getTranslatedString('passwordsMustMatch')}
      />
    </Fragment>
  );
};

const StyledCheckmark = styled(MdCheck)`
  padding: 0;
  margin-right: 8px;
  text-align: center;
  color: ${(props) => props.color};
`;

const StyledBullet = styled(MdFiberManualRecord)`
  padding: 0;
  margin-right: 8px;
  text-align: center;
  color: ${(props) => props.color};
  font-size: 10px;
`;

const RequirementRow = ({ passed = false, translatedText }) => {
  let iconColor = passed ? colors.CHECKMARK_GREEN : colors.DISABLED_GRAY;
  const textColor = colors.MED_DARK_GRAY;
  return (
    <div className="row" style={{ textAlign: 'left' }}>
      <div style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
        {passed ? <StyledCheckmark color={iconColor} /> : <StyledBullet color={iconColor} />}
      </div>
      <div style={{ display: 'inline-flex' }}>
        <p style={{ color: textColor, fontSize: '12px', marginBottom: '6px' }}>{translatedText}</p>
      </div>
    </div>
  );
};

export default PasswordRequirements;
